import React from 'react';

const TermsOfService = () => {
  return (
    <div>
      <iframe
        title="termsOfServiceFrame"
        width="100%"
        style={{ height: '95vh' }}
        src="https://app.termly.io/document/terms-of-use-for-ecommerce/5490056b-b95c-4cf6-944a-cb53805dd56a"
        frameborder="0"
        allowfullscreen
      >
        <p>Your browser does not support iframes.</p>
      </iframe>
    </div>
  );
};

export default TermsOfService;



// WEBPACK FOOTER //
// ./src/components/TermsOfService.js